import React, {Component} from 'react';
import SearchPanel from './search_panel';
import {commonService} from "../../_services";
import { appConstants } from "../../_constants";
import {store} from "../../_store";
import {alertActions, commonActions} from "../../_actions";
import { connect } from "react-redux";
import RecordTable from "./record";
import GridContainer from "../../components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import {EmptyRecord} from "../../utils/PageUtility";
import withStyles from "@material-ui/core/styles/withStyles";
import withMobileDialog from "@material-ui/core/withMobileDialog/withMobileDialog";
import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.jsx";
import ViewTemplate from "./viewTemplate";

class MakerChecker extends Component {
    constructor(props) {
        super(props);
        this.state = {
            EntityId: "-1",
            statusId: "-1",
            entities: [],
            Status: [
                {Name: "All Status", type: '-1' },
                { Name: "Pending", Id_: appConstants.MAKER_CHECKER_STATUS.PENDING, type: 1 },
                { Name: "Approved", Id_: appConstants.MAKER_CHECKER_STATUS.APPROVED, type: 1 },
                { Name: "Rejected", Id_: appConstants.MAKER_CHECKER_STATUS.REJECTED, type: 1 }
            ],
            pageSize: 10,
            record: [],
            fetchedRecords: false,
            totalCount: 0,
            currentPage: 1,
            PayloadViewTemplate: false,
            ActiveRecord: false,
            Comment: '',
            openModal: false,
            ErrorMessage: ""
        }
    };

    componentDidMount() {
        const reduxState = store.getState(); //get redux state
        let {entityTypes} = reduxState;   //destructure entity types from redux state
        const { dispatch} = this.props;

        //If no entityTypes in store, dispatch action to get entity types
        if(!entityTypes){
            dispatch(commonActions.getEntityTypes())
        }else{
            //if there is entityTypes in store, set entities in state to entityTypes
            this.setState({entities: entityTypes})
        }
        this.searchMakerChecker();  //call search maker checker endpoint to fetch maker checker record

    }

    componentWillReceiveProps = function (nextProps) {
        const {entityTypes} = nextProps;

        if (entityTypes){
            let modifiedEntityTypes = [...entityTypes];
            let allEntityTypes = {EntityType: "All Entities", EntityTypeId: "-1"};
            modifiedEntityTypes.unshift(allEntityTypes);
            this.setState({entities: modifiedEntityTypes})
        }
        };


    setEntityTypes = (entityTypes) => {
        let createBillablePscEntityTypeId;

        entityTypes.forEach(entity =>{
            if(entity.EntityType === appConstants.APP_ENTITIES.BILLABLE_PASSENGER_SETTINGS){
                createBillablePscEntityTypeId = entity.EntityTypeId;
            }

        });
        this.setState({createBillablePscEntityTypeId})

    };

    //method to handle change of select input.
    handleSelectChange = event => {
        this.setState({ [event.target.name] : event.target.value});
    };

    handleReactSelectChange = (value, name) => {
        this.setState({[name.name]: value.value});
    };

    //method to search and fetch maker checker records
    searchMakerChecker = (pageNumber = 1) => {
        const {EntityId, statusId, pageSize} = this.state;
         let {dispatch, user} = this.props;

         let payload = {
            "AppId": appConstants.MAKER_CHECKER_APP_ID,
             "UserName": user.userId,
             "from": pageNumber,
             "Size": pageSize,
             "RoleName": user.userRole
         };

         if(EntityId !== '-1') {
             payload.EntityTypeId = EntityId
         }
         if(statusId !== '-1') {
             payload.StatusId = statusId
         }
         if(statusId === "-1") {
             payload.StatusId = null;
         }
         // if(EntityId === '-1') {
         //     payload.EntityTypeId = null;
         // }
        // console.log('payload', payload);
         dispatch(alertActions.startRequest());
         commonService.searchMakerChecker(payload) //endpoint call to fetch maker checker record
             .then(res => {
                 dispatch(alertActions.stopRequest());
                 if (res.status === appConstants.SUCCESS_RESPONSE) {
                     this.setState({
                         record: res.response.MakeCheck,
                         fetchedRecords: true,
                         currentPage: pageNumber,
                         totalCount: res.response.TotalCount
                     })
                 }
                 else if (res.status === appConstants.ERROR_RESPONSE) {
                     dispatch(alertActions.error(res.response));
                     this.setState({ fetchedRecords: false });
                 }
             })
    };

    //method to open approval modal.
    // Pass the particular record details as argument to be displayed in the modal.
handleApprovalModal = (ActiveRecord) => {
    const PayloadViewTemplate = JSON.parse(ActiveRecord.PayloadViewTemplate);
    this.setState({ ActiveRecord, PayloadViewTemplate, openModal: !this.state.openModal});

};

//method to toggle Approval method
toggleModal = () => {
    this.setState({ openModal: !this.state.openModal});
};

//method for Approving maker checker records
handleApproval = (status) => {
    const {Comment, ActiveRecord} = this.state;
    const {dispatch, user} = this.props;

    if (Comment === "") {
        dispatch(alertActions.error("Please provide a comment"));
        this.setState({ErrorMessage: "Please provide a comment"})
    } else {
        dispatch(alertActions.startRequest());
        const payload = {
            MakeCheckerId: ActiveRecord.Id,
            UserName: user.userName,
            Comment
        };

        //variable that holds the request sent to either the maker checker approval endpoint or maker checker rejection endpoint
        let requestHTTP = (status === appConstants.MAKER_CHECKER_STATUS.APPROVED) ? commonService.approveMakerChecker(payload) : commonService.rejectMakerChecker(payload);
        requestHTTP.then(res => {
            if(res.status === appConstants.SUCCESS_RESPONSE) {
                const successMessage = (status === appConstants.MAKER_CHECKER_STATUS.APPROVED) ? "Record approved successfully" : "Record rejected successfully";
                dispatch(alertActions.notify(successMessage));
                this.toggleModal();
                this.searchMakerChecker();
                dispatch(alertActions.stopRequest());
            }
            else if(res.status === appConstants.ERROR_RESPONSE){
                dispatch(alertActions.error(res.response));
                dispatch(alertActions.stopRequest());
            }

    })
    }
};

//method for changing of input fields in Approval modal
handleChange = (event) => {
    // console.log('event.target.name', event.target.name, "event.target.value", event.target.value)
    this.setState({[event.target.name]: event.target.value});
};

//method to handle closing of the approval modal
closeModal = () => {
    this.setState({openModal: false})
};


    render() {
        const { classes, user } = this.props;
        const {EntityId, entities, Status, statusId, record,
            fetchedRecords, currentPage, totalCount, pageSize,
            openModal, ActiveRecord, Comment, PayloadViewTemplate} = this.state;
        // console.log('totalCount', totalCount,'currentPage', currentPage, 'pageSize', pageSize,  'fetchedRecords', fetchedRecords, 'totalCount', totalCount);
        return (
            <div>
                <SearchPanel
                    EntityId={EntityId}
                    entities={entities}
                    Status={Status}
                    statusId={statusId}
                    selectChange={this.handleReactSelectChange}
                    onSearch={this.searchMakerChecker}
                />
                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <Card>
                            <CardHeader color="regional">
                                <h4 className={classes.cardTitleWhite}>
                                    Records
                                </h4>
                            </CardHeader>
                            <CardBody>
                                {
                                    ( totalCount === 0)
                                    &&
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <EmptyRecord message={'No record'}/>
                                        </GridItem>
                                    </GridContainer>
                                }
                                {
                                    (fetchedRecords && totalCount > 0)
                                    &&
                                    <RecordTable
                                        data={record}
                                        currentPage={currentPage}
                                        pageSize={pageSize}
                                        totalCount={totalCount}
                                        handleApprovalModal={this.handleApprovalModal}
                                        fetchMakerCheckerRecord={this.searchMakerChecker}
                                    />
                                }
                            </CardBody>
                        </Card>
                    </GridItem>
                </GridContainer>
                <GridContainer>
                    <ViewTemplate
                        isModalOpen={openModal}
                        record={ActiveRecord}
                        Comment={Comment}
                        payload={PayloadViewTemplate}
                        handleChange={this.handleChange}
                        user={user}
                        closeModal={this.closeModal}
                        handleApproval={this.handleApproval}
                        makerCheckerApprovalId={appConstants.MAKER_CHECKER_STATUS.APPROVED}
                        makerCheckerRejectionId={appConstants.MAKER_CHECKER_STATUS.REJECTED}
                        disabled={this.props.requesting}
                        // classes={}
                    />
                </GridContainer>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { user, users, requesting, entityTypes } = state;
    return {
        user,
        users,
        requesting,
        entityTypes
    };
}

export default connect(mapStateToProps)(withMobileDialog()(withStyles(dashboardStyle)(MakerChecker)));

/* Written with love by Juliet April 2019 */


// WEBPACK FOOTER //
// ./src/Regional-Views/MakerChecker/Index.jsx